// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"bf53e272","379":"4abc603d","787":"f8769da0","908":"5f00209c"}[chunkId] + ".chunk.js";
};